import styled from 'styled-components'
import { HStack } from '../../global/styles'

// eslint-disable-next-line import/prefer-default-export
export const TabsWrap = styled(HStack).attrs({ as: 'ul' })`
  height: 52px;
  z-index: 10;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.03);
`
